import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 11L11 5" stroke="#D14020" />
      <path d="M11 11L5 5" stroke="#D14020" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#D14020" />
    </Svg>
  );
};

export default Icon;
